import { get, post, put, del } from 'aws-amplify/api';
import { UnauthorizedInterceptor } from './unauthorizedInterceptor';

export const getSsoBase = () => {
    const strip = (s = '') => s.replace(/\/$/, '');
    const firstSeg = (p = '') => p.match(/^\/[^/]+/)?.[0] || '';
    const domain = strip(process.env.REACT_APP_API_URL_DOMAIN || '');
    const stage = firstSeg(process.env.REACT_APP_ENDPOINT_PREFIX || '');
    return `${domain}${stage}`;
};

const parseQueryStringParameters = (url = '') => {
    const parts = url.split('?');
    const params = parts[1];
    const queryStringParameters = {};
    if (!params) return { parts, queryStringParameters };

    params.split('&').forEach((p) => {
        const [k, v] = p.split('=');
        if (k) queryStringParameters[k] = v;
    });

    return { parts, queryStringParameters };
};

export const doRequest = async (method, headers, url, body, bypassCache = true) => {
    let resp = null;
    const { parts, queryStringParameters } = parseQueryStringParameters(url);

    const path = `${process.env.REACT_APP_ENDPOINT_PREFIX}${parts[0]}`;

    try {
        if (method === 'GET') {
            resp = await get({
                apiName: 'portalApi',
                path,
                options: {
                    headers,
                    queryParams: queryStringParameters,
                },
            });
        } else if (method === 'POST') {
            resp = await post({
                apiName: 'portalApi',
                path,
                options: {
                    headers,
                    queryParams: queryStringParameters,
                    body,
                },
            });
        } else if (method === 'PUT') {
            resp = await put({
                apiName: 'portalApi',
                path,
                options: {
                    headers,
                    queryParams: queryStringParameters,
                    body,
                },
            });
        } else if (method === 'DELETE') {
            resp = await del({
                apiName: 'portalApi',
                path,
                options: {
                    headers,
                    queryParams: queryStringParameters,
                },
            });
        } else {
            throw new Error(`Método HTTP não suportado: ${method}`);
        }

        // Amplify v6+: get/post/put/del retornam uma operação cancelável com `response: Promise`.
        // Amplify antigo: pode retornar um objeto com `body` diretamente.
        const response = resp?.response ? await resp.response : resp;
        const data = response?.body ? await response.body.json().catch(() => null) : null;
        return data ?? response;
    } catch (e) {
        console.error(e);
        const status = e?.response?.statusCode ?? e?.statusCode ?? e?.response?.status ?? null;
        const authenticationRoutes = ["/login", "/new-password"]
        const isAuthRoute = authenticationRoutes.indexOf(parts[0]) !== -1;
        if (status === 401 && !isAuthRoute) {
            UnauthorizedInterceptor.handleUnauthorized();
        }

        if (status) {
            let errBody = null;
            try {
                errBody = e?.response?.body ? await e.response.body.json() : e?.response?.data;
            } catch {
                errBody = e?.message;
            }
            return {
                httpStatus: status,
                body: errBody,
            };
        }

        throw e;
    }
};

export const doGet = async (url, options) => {
    if (options?.cache) {
        const strCache = sessionStorage.getItem(url);
        if (strCache) {
            const record = JSON.parse(strCache);
            if (record.timestamp >= new Date().getTime() && record.record.httpStatus === 200) {
                return record.record;
            }
        }
    }
    const resp = await doRequest('GET', {}, url);

    if (options?.cache && resp.httpStatus === 200) {
        sessionStorage.setItem(
            url,
            JSON.stringify({
                timestamp: new Date().getTime() + 1000 * (options.expireInSeconds ?? 30),
                record: resp,
            })
        );
    }
    return resp;
};

export const doPost = (url, data) => {
    return doRequest('POST', { 'Content-Type': 'application/json' }, url, data);
};

export const doDelete = (url, data) => {
    return doRequest('DELETE', {}, url, data);
};

export const doPut = (url, data) => {
    return doRequest('PUT', {}, url, data);
};
